import { SupportingTextOperator, SupportingTextVisibility, } from './types.js';
// A condition question with no real answer, or one skip logic hides, matches no
// condition whatever its operator; a block on a question skip logic hides is never
// shown. Text answers never take part: condition questions are always choice questions.
function conditionMatches(condition, answers, hidden) {
    if (hidden.has(condition.questionId))
        return false;
    const answer = answers.get(condition.questionId);
    if (!answer)
        return false;
    const picked = condition.optionIds.some((id) => answer.selectedOptionIds.includes(id));
    switch (condition.operator) {
        case SupportingTextOperator.Equals:
        case SupportingTextOperator.HasAnyOf:
            return picked;
        case SupportingTextOperator.DoesNotEqual:
        case SupportingTextOperator.HasNoneOf:
            return !picked;
        default:
            return false;
    }
}
/** Groups are alternatives; a group holds when every condition in it holds. */
function ruleMatches(groups, answers, hidden) {
    return groups.some((group) => group.length > 0 && group.every((c) => conditionMatches(c, answers, hidden)));
}
function isVisible(block, answers, hidden) {
    switch (block.visibility) {
        case SupportingTextVisibility.ShowIf:
            return ruleMatches(block.groups, answers, hidden);
        case SupportingTextVisibility.HideIf:
            return !ruleMatches(block.groups, answers, hidden);
        default:
            return true;
    }
}
/** The ids of the blocks to render for these answers and this set of hidden questions. */
export function evaluateSupportingTexts(blocks, answers, hiddenQuestionIds) {
    const visible = new Set();
    for (const block of blocks) {
        if (hiddenQuestionIds.has(block.questionId))
            continue;
        if (isVisible(block, answers, hiddenQuestionIds))
            visible.add(block.id);
    }
    return visible;
}
//# sourceMappingURL=evaluate.js.map